import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

export const withCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes(environment.firebaseCloudFunctionsBaseUrl)) {
    return next(req);
  }

  const requestWithCredentials = req.clone({
    withCredentials: true,
  });
  return next(requestWithCredentials);
};
